import { useRef, useEffect } from 'react';

interface EditableSpanProps {
  value: string;
  onChange: (v: string) => void;
  className?: string;
  tag?: 'span' | 'p' | 'h4';
}

export function EditableSpan({ value, onChange, className, tag: Tag = 'span' }: EditableSpanProps) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el && el !== document.activeElement) {
      el.textContent = value || '';
    }
  });

  return (
    <Tag
      ref={ref as React.RefObject<HTMLElement & HTMLSpanElement & HTMLParagraphElement & HTMLHeadingElement>}
      className={`pvx-editable${className ? ' ' + className : ''}`}
      contentEditable
      suppressContentEditableWarning
      onFocus={() => ref.current?.classList.add('pvx-editing')}
      onBlur={e => {
        const el = ref.current;
        if (el) {
          el.classList.remove('pvx-editing');
          el.classList.add('pvx-saved');
          setTimeout(() => el.classList.remove('pvx-saved'), 800);
        }
        onChange(e.currentTarget.textContent ?? '');
      }}
    />
  );
}
